import api from './api';
import { Tenant } from '@/types';

export interface TenantWithAdminCreate {
  tenant_name: string;
  tenant_slug: string;
  tenant_address?: string;
  tenant_phone?: string;
  tenant_email?: string;
  admin_email: string;
  admin_full_name: string;
}

export interface TenantWithAdminResponse {
  tenant: Tenant;
  admin_email: string;
  admin_name: string;
  temporary_password: string;
  email_sent: boolean;
}

export interface TenantProfileUpdate {
  name?: string;
  address?: string;
  phone?: string;
  stock_alert_threshold_default?: number;
  expiration_alert_days?: number;
  card_surcharge_percent?: number;
  price_by_payment_method?: boolean;
  cash_rounding_enabled?: boolean;
  card_single_installment_as_cash?: boolean;
  calendar_start_hour?: number;
  calendar_end_hour?: number;
  // Plantillas de los recordatorios de WhatsApp (vacías = texto por defecto)
  reminder_template_visit?: string;
  reminder_template_vaccine?: string;
  reminder_template_deworming?: string;
  reminder_template_grooming?: string;
  reminder_template_appointment?: string;
}

export type ReminderTemplateKind = 'visit' | 'vaccine' | 'deworming' | 'grooming' | 'appointment';

export interface ReminderTemplateDefaults {
  defaults: Record<ReminderTemplateKind, string>;
  variables: Record<ReminderTemplateKind, string[]>;
}

export const tenantsService = {
  // Textos por defecto de los recordatorios y variables que acepta cada uno
  async getReminderTemplateDefaults(): Promise<ReminderTemplateDefaults> {
    const response = await api.get<ReminderTemplateDefaults>('/tenant/reminder-templates/defaults');
    return response.data;
  },

  async getTenants(): Promise<Tenant[]> {
    const response = await api.get<Tenant[]>('/auth/tenants');
    return response.data;
  },

  async createTenant(data: TenantWithAdminCreate): Promise<TenantWithAdminResponse> {
    const response = await api.post<TenantWithAdminResponse>('/auth/tenants', data);
    return response.data;
  },

  // Perfil de la veterinaria actual
  async getProfile(): Promise<Tenant> {
    const response = await api.get<Tenant>('/tenant/profile');
    return response.data;
  },

  async updateProfile(data: TenantProfileUpdate): Promise<Tenant> {
    const response = await api.put<Tenant>('/tenant/profile', data);
    return response.data;
  },

  async uploadLogo(file: File): Promise<Tenant> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post<Tenant>('/tenant/profile/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async deleteLogo(): Promise<Tenant> {
    const response = await api.delete<Tenant>('/tenant/profile/logo');
    return response.data;
  },
};
